module.exports = __webpack_public_path__ + "img/classic_blue.09230b29.png";